import { format, formatISO, isValid, parseISO } from 'date-fns';
import { Injectable } from '@angular/core';
import { LogService } from '../../util/log.service';
import { II11Transformer } from '../generic-api-client.service';
import { IEntryCodeModel } from './entry-code-model.interface';

@Injectable({
  providedIn: 'root'
})
export class EntryCodeTransformService implements II11Transformer<IEntryCodeModel> {
  constructor(private readonly log: LogService) {}

  transformItem(item: IEntryCodeModel): IEntryCodeModel {
    if (!item) {
      return {} as IEntryCodeModel;
    }
    const transformedItem: IEntryCodeModel = { ...item };
    const dateFields: (keyof IEntryCodeModel)[] = ['valid_to', 'created_at', 'updated_at'];
    dateFields.forEach((field) => {
      if (item[field] && typeof item[field] === 'string') {
        const date = parseISO(item[field] as string);
        if (isValid(date)) {
          (transformedItem[field] as any) = format(date, 'yyyy-MM-dd HH:mm:ss');
        } else {
          this.log.warn(`EntryCodeTransformService: Invalid ${String(field)} for entry code ID ${item.id}: ${item[field]}`);
        }
      }
    });
    return transformedItem;
  }

  serializeItem(item: IEntryCodeModel): Partial<IEntryCodeModel> {
    if (!item) {
      return {};
    }
    const {
      id,
      '@id': id_iri,
      created_at,
      updated_at, // read-only
      user,
      ...rest
    } = item;
    const serializedItem: Partial<IEntryCodeModel> = { ...rest };
    if (item.valid_to) {
      const date = parseISO(item.valid_to);
      if (isValid(date)) {
        serializedItem.valid_to = formatISO(date);
      } else {
        this.log.warn(`EntryCodeTransformService: Could not serialize invalid valid_to date: ${item.valid_to}`);
      }
    }
    /* if (user && typeof user === 'object' && '@id' in user) {
      serializedItem.user = user['@id'];
    } else if (typeof user === 'string') {
      serializedItem.user = user;
    } */
    return serializedItem;
  }
}
